<template>
	<div class="hover-view">
		<div v-if="item" :class="['body', align]" :style="{
			gridTemplateColumns: gridTemplateColumns
		}">
			<div class="type" :style="{
				backgroundColor: '#f7223f'
			}">
				<div class="label">Timer</div>
				<div class="tp"></div>
			</div>
			<div class="label">
				{{ item.name }}
				<div class="num">
					{{ date | date }}
				</div>
			</div>
			<div class="info">
				<table cellspacing="5" cellpadding="0">
					<tr>
						<td class="label">Timer</td>
						<td class="value">{{ item.hours | roundHours | formatHours }}</td>
					</tr>
					<tr>
						<td class="label">Pause</td>
						<td class="value">{{ item.pause | roundHours | formatHours }}</td>
					</tr>
					<tr>
						<td class="label">Godkendt</td>
						<td class="value" v-if="item.approved">{{ item.approved | roundHours | formatHours }}</td>
						<td class="value" v-if="!item.approved">-</td>
					</tr>	
					<tr>
						<td class="label">Tillæg</td>
						<td class="value" v-if="item.extra">{{ item.extra | number }}</td>
						<td class="value" v-if="!item.extra">-</td>
					</tr>	
					<tr>
						<td class="label">Overført</td>
						<td class="value">{{ item.transferred ? $options.filters.date(item.transferred) : '-' }}</td>
					</tr>				
					<tr>
						<td class="sep" colspan="2"></td>
					</tr>
					<tr>
						<td class="label">Notifikationer</td>
						<td class="value">{{ item.app_id !== null ? 'Ja' : 'Nej' }} ( {{ item.notifications.length }} )</td>
					</tr>
					<tr>
						<td class="sep" colspan="2"></td>
					</tr>
					<div class="block">
						<div class="title">Bemærkninger</div>
						<div class="desc">{{ item.remarks ? item.remarks : '-' }}</div>
					</div>
				</table>
			</div>
			<div class="dyn team">
				<div class="title">Dagens opgaver ( {{ item.tasks.length + item.tasksExt.length }} )</div>
				<div class="block" v-for="(t, r) in item.tasks" :key="`task${r}`">
					<div class="desc">#{{ t.num }}, {{ t.full ? t.full.name : '[ Opgaven er ikke planlagt til denne dag ]' }}</div>
				</div>
				<div class="block" v-for="(t, r) in item.tasksExt" :key="`taskext${r}`">
					<div class="desc">#{{ t.num }}, {{ t.name }}</div>
				</div>
				<div v-if="item.tasks.length + item.tasksExt.length == 0" class="block">
					<div class="desc">Ingen planlagte opgaver</div>
				</div>
			</div>
			<div class="info team dyn events">
				<div class="title">Dagens stempler ( {{ item.allStamps.length }} )</div>
				<table v-if="item.allStamps.length > 0" cellspacing="5" cellpadding="0">
					<tr v-for="(s, i) in item.allStamps" :key="`stamp${i}`">
						<td class="value label" style="font-family: 'Roboto Mono'; font-size: 11px;">{{ s.time }}</td>
						<td class="label" style="white-space: nowrap; font-size: 11px;">{{ s.type == 'in' && s.task_id === null ? 'Stempel ind' : (s.type == 'in' ? 'Check ind' : (s.type == 'out' && s.task_id === null ? 'Stempel ud' : (s.type == 'out' ? 'Check ud' : (s.type == 'pause' ? 'Pause' : (s.type == 'resume' ? 'Genoptaget' : '-'))))) }}</td>
						<td class="right" style="white-space: nowrap; text-overflow: ellipsis; font-size: 11px;">{{ s.address }}</td>
					</tr>
				</table>
				<div v-if="item.allStamps.length == 0" class="block">
					<div class="desc">Ingen stempler</div>
				</div>
			</div>
			<div class="dyn team">
				<div class="title">Bemærkninger</div>
				<div class="block" v-for="(rem, r) in item.comments" :key="`comment${r}`">
					<div class="desc">{{ rem.message }}</div>
				</div>
				<div v-if="item.comments.length == 0" class="block">
					<div class="desc">Ingen bemærkninger</div>
				</div>
			</div>
			<div class="dyn instr">
				<div class="title">Advarsler</div>
				<div class="block" v-for="(warn, w) in item.warnings" :key="`warning${w}`">
					<div class="desc">{{ warn }}</div>
				</div>
				<div v-if="item.warnings.length == 0" class="block">
					<div class="desc">Ingen bemærkninger</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				colors: {
					in: '#00c017',
					out: '#f7223f'
				}
			};
		},
		props: {
			date: {
				type: String,
				default: ''
			},
			item: {
				type: Object,
				default: null
			},
			align: {
				type: String,
				default: 'right'
			},
			types: {
				type: Object,
				default() {
					return {};
				}
			},
			employees: {
				type: Object,
				default() {
					return {};
				}
			},
			departments: {
				type: Object,
				default() {
					return {};
				}
			},
			instructions: {
				type: Object,
				default() {
					return {};
				}
			}
		},
		methods: {
			
		},
		computed: {
			gridTemplateColumns() {
				var cols = ['30px', 'auto', 'auto', 'auto', 'auto'];

				cols.splice(cols.length - 2, 0, 'auto [semi]');

				return cols.join(' ') + ' [end]';
			}
		},
		watch: {
			types(n) {
				
			}
		}
	}
</script>

<style lang="scss" scoped>
	.hover-view {
		pointer-events: none;
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;

		& > .body {
			&.left {
				left: 20px;
			}

			&.right {
				right: 20px;
			}

			background-color: white;
			border-radius: 5px;
			overflow: hidden;
			position: absolute;
			bottom: 20px;
			display: grid;
			grid-template-rows: auto 1fr 20px;

			-webkit-box-shadow: 2px 2px 12px -6px rgba(0,0,0,1);
			-moz-box-shadow: 2px 2px 12px -6px rgba(0,0,0,1);
			box-shadow: 2px 2px 12px -6px rgba(0,0,0,1);

			& > .type {
				color: white;
				font-weight: bold;
				grid-column: 1;
				grid-row: 1 / 4;
				position: relative;

				& > .label {
					position: absolute;
					bottom: 0;
					left: 30px;
					line-height: 30px;
					font-size: 12px;
					white-space: nowrap;
	
					transform: rotate(-90deg);
					transform-origin: bottom left;
					padding-left: 10px;
				}

				& > .tp {
					position: absolute;
					top: 0;
					left: 30px;
					line-height: 30px;
					font-size: 12px;
	
					transform: rotate(-90deg);
					transform-origin: bottom left;
					padding-right: 10px;
				}
			}

			& > .label {
				grid-column: 2 / end;
				grid-row: 1;
				padding: 20px;
				font-size: 16px;
				font-weight: bold;

				& > .num {
					float: right;
					font-size: 16px;
					font-weight: bold;
				}
			}

			& > .info {
				padding: 0 30px 0 20px;
				max-width: 500px;
				
				& > table td {
					vertical-align: top;
					font-size: 14px;

					::v-deep .tag {
						display: inline-block;
						background-color: #f7223f;
						font-size: 12px;
						color: white;
						padding: 3px 5px 3px 5px;
						border-radius: 3px;
						margin-top: 4px;
						margin-bottom: 6px;
					}

					&.label {
						padding-right: 20px;
					}

					&.value {
						font-weight: bold;
					}

					&.sep {
						height: 10px;
					}

					&.right {
						text-align: right;
					}
				}

				&.events {
					padding-right: 20px;

					& table {
						margin-top: 10px;
						width: 100%;
					}

					& table td {
						font-size: 12px;
						border-top: 1px solid #e9e9e9;
					}

					& table tr:first-child td {
						border-top: none;
					}
				}
			}

			& > .dyn {
				border-left: 1px solid #e9e9e9;
				padding: 0 50px 0 20px;

				&.instr {
					max-width: 300px;
				}

				& > .title {
					font-weight: bold;
				}

				& > .block {
					padding-top: 10px;

					& > .title {
						font-size: 14px;
						font-weight: bold;
						margin-bottom: 3px;
					}

					& > .desc {
						padding-top: 5px;
						font-size: 14px;

						& > .status {
							display: inline-block;
							width: 6px;
							height: 6px;
							border-radius: 50%;
							margin-right: 8px;
							position: relative;
							top: -2px;
						}
					}
				}
			}
		}
	}
</style>